<div class="flex flex-column gap-20px">
    <h2 class="m-0"> Performance</h2>
    <div class="flex flex-wrap gap-2">
        <p-dropdown styleClass="dropdown-rounded" 
            [autoDisplayFirst]="false" 
            [options]="timeFrameList"
            scrollHeight="300px" 
            [formControl]="timeFrameControl"
        >
        </p-dropdown>
    </div>

    <div class="grid">
        @if (stats$ | async; as stats) {
        @if (stats.data?.CompletionRiskOverTime; as completionScores) {
        <div class="col-12 w-full">
            <div class="custom-chart-wrapper">
                <app-graphic-line class="h-15rem" 
                    [title]="'Submissions'" 
                    [data]="completionScores.averageScores"
                    [meta]="completionScores.meta" 
                    [chartData$]="completionAsapDataSet$" 
                    [chartOptions]="ChartOptions"
                >
                </app-graphic-line>
            </div>
        </div>
        }

        @if (stats?.data?.TopSubmissionByUsers; as submissions) {
        <div class="col-12 w-full">
            <app-graphic-submission-table class="h-full" 
                [title]="'Top Submissions by User'" 
                [data]="submissions.data"
                [meta]="submissions.meta"
                >
            </app-graphic-submission-table>
        </div>
        }

       

        @if (stats.data?.SubmissionCountsByHourBucketDynamic; as participationRate) {
        <div class="col-12 w-full">
            <div class="custom-chart-wrapper">
                <app-graphic-line class="h-15rem" 
                    [title]="'Participation Rate'"
                    [data]="participationRate.averageScores" 
                    [meta]="participationRate.meta"
                    [chartData$]="participationRateDataSet$" 
                    [chartOptions]="ChartOptions"
                >
                </app-graphic-line>
            </div>
        </div>
        }
        @if (stats.data?.AssignedRiskMitigationOverTime; as assignedRiskMitigationAsap) {
            <div class="col-12 w-full">
                <div class="custom-chart-wrapper">
                    <app-graphic-line class="h-15rem" 
                        [title]="'Assigned Risk Mitigation'"
                        [data]="assignedRiskMitigationAsap.averageScores" 
                        [meta]="assignedRiskMitigationAsap.meta"
                        [chartData$]="assignedRiskMitigationAsapDataSet$" 
                        [chartOptions]="ChartOptions"
                    >
                    </app-graphic-line>
                </div>
            </div>
            }
        }
    </div>
</div>